import dayjs from "dayjs"

const getInvestmentInitialValues = ({ lead }) => {
  const probabilityManual = +lead?.probabilityManual ?? +lead?.percentage
  const closingMonth = lead?.closingMonth ? dayjs(lead?.closingMonth).startOf("month") : dayjs().startOf("month")
  return {
    interestedProjectId: lead?.interestedProjectId || null,
    dealValue: lead?.totalDealValue ?? undefined,
    expectedRevenue: lead?.totalExpectedRevenue ?? undefined,
    pipelineStageId: lead?.stageId || null,
    pipelineSubStageId: lead?.subStageId || null,
    probabilityManual,
    closingMonth: closingMonth.isValid() ? closingMonth : dayjs().startOf("month"),
    comment: lead?.comment ?? "",
  }
}

export default getInvestmentInitialValues
